
import axios from '@/service/request';
import type { CateringCategoryCodeEnum, PageR } from './types';

export interface CouponPageRequest {
  /**
   * 优惠券id
   */
  couponId?: number;
  /**
   * 页码
   */
  current?: number;
  /**
   * 每页大小
   */
  size?: number;
  /**
   * 分类code
   */
  categoryCode?: string;
}

/**
* PageMiniCouponResponse
*/
export interface PageMiniCouponResponse {
  /**
   * countId
   */
  countId?: string;
  /**
   * 当前页
   */
  current?: number;
  /**
   * 单页分页条数限制
   */
  maxLimit?: number;
  /**
   * 自动优化 COUNT SQL
   */
  optimizeCountSql?: boolean;
  /**
   * {@link #optimizeJoinOfCountSql()}
   */
  optimizeJoinOfCountSql?: boolean;
  /**
   * 排序字段信息
   */
  orders?: OrderItem[];
  /**
   * 查询数据列表
   */
  records?: MiniCouponResponse[];
  /**
   * 是否进行 count 查询
   */
  searchCount?: boolean;
  /**
   * 每页显示条数，默认 10
   */
  size?: number;
  /**
   * 总数
   */
  total?: number;
  [property: string]: any;
}

/**
* com.baomidou.mybatisplus.core.metadata.OrderItem
*
* OrderItem
*/
export interface OrderItem {
  asc?: boolean;
  column?: string;
}

/**
* 优惠券响应参数
*
* MiniCouponResponse
*/
export interface MiniCouponResponse {
  /**
   * 分类编码
   */
  categoryCode: CateringCategoryCodeEnum;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 优惠券id
   */
  id?: number;
  /**
   * 图片URL
   */
  imageUrl?: string;
  /**
   * 店铺名称
   */
  shopName?: string;
  /**
   * 排序值
   */
  sort?: number;
  /**
   * 修改时间
   */
  updateTime?: string;
}


/**
 * 优惠券列表
 *
 * @param {CouponPageRequest} data
 * @return {*}  {Promise<R<MiniCouponResponse>>}
 */
export const apiCouponPage = (data: CouponPageRequest, config?: AxiosRequestConfig): Promise<PageR<MiniCouponResponse>> => {
  return axios.post('/promotion/couponPage', data, config);
};

